import { GET_OTROS_DATOS_CIERRE_DIARIO, MODIFY_FIELD_OTROSDATOS_CIERRE } from '../constants/action_types';

const initialState = { datos: {}, top5: {}, tieneTokens: true, isLoading: false, loaded: false };

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_OTROS_DATOS_CIERRE_DIARIO:

            return {
                datos: {},
                top5: {},
                tieneTokens: true,
                isLoading: true,
                loaded: false
            };

        case GET_OTROS_DATOS_CIERRE_DIARIO + "_SUCCESS":

            return {
                datos: action.payload.data.datos,
                top5: action.payload.data.top5,
                tieneTokens: action.payload.data.tieneTokens,
                isLoading: false,
                loaded: true
            };

        case MODIFY_FIELD_OTROSDATOS_CIERRE:

            return {
                datos: {...state.datos, [action.payload.field]: action.payload.value},
                top5: state.top5,
                tieneTokens: state.tieneTokens,
                isLoading: false,
                loaded: true
            };

        default:

            return state;
    };
};